import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useSummaryModel } from "./summaryModel";
import { useGlobalModel } from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useSummaryModel();

    const { appDs } = useGlobalModel(({ appDs }) => [appDs]);
    const { getSelectedDictOne } = useDictModel(() => []);

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "name",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "客户类型",
            fieldName: "categoryCode",
            size: "small",
            disabled: false,
            options: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE)
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统分支",
            fieldName: "branch",
            size: "small",
            options: appDs,
        },
    ]

    return (
        <YhPageHeader
            title="客户账户"
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}